module.exports = __webpack_public_path__ + "static/media/1013522.84b21874.jpg";